import Vue from 'vue'
import Component from './index.vue'

let newInstance = null

//将vue组件变为构造函数
let ComponentConstructor = Vue.extend(Component)

let init = (options)=>{
    //实例化组件
    newInstance = new ComponentConstructor()
   //合并配置选项
    Object.assign(newInstance,options)
    newInstance.uname = options.uname;
   //使用$mount()后  可以理解为创建虚拟的dom
    document.body.appendChild(newInstance.$mount().$el)
}
let dialogCommon = (options)=>{
    //options 为调用组件方法时传入的配置选项
    if(!newInstance){
        init(options)
    }
    return newInstance.show(() =>{newInstance = null})
}
export default dialogCommon